import Vue from 'vue';

Vue.component('tng-rfid-reimbursement-index', () =>
    import(/* webpackChunkName: 'tng-rfid-reimbursement-datatable' */ './tng-rfid-reimbursement-index'),
);
